
export * from '../../frontend-editor-ckeditor-web/__liferay__/index.js';
